import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google-session`, { session_id }, { withCredentials: true });
        setUser(data.user);
        // strip hash and go to /app
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/app", { replace: true, state: { user: data.user } });
      } catch (e) {
        setErr(e?.response?.data?.detail || "Falha no login Google");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-slate-950 text-white grid place-items-center">
      <div className="text-center">
        <div className="h-12 w-12 mx-auto rounded-full border-2 border-emerald-500 border-t-transparent animate-spin" />
        <div className="mt-4 text-sm text-slate-300">{err ? err : "Conectando sua conta Google..."}</div>
        {err && <button onClick={() => navigate("/login")} className="mt-4 text-emerald-300 text-sm underline">Voltar ao login</button>}
      </div>
    </div>
  );
}
